import { globalPrompt } from '@/components/message'
import { createModel } from 'hox'
import { useRef, useState } from 'react'
import { supplierService } from '../../../supplierService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/ScmTypes'
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import { ISupplierContractPageSearchFields, ISupplierContractDetails, ISupplierContractInsert } from '@/views/supplier/supplierTypes'
import { TablePaginationConfig } from 'antd/lib/table'
import { debounce } from 'lodash'

export const useSupplyDetailsMode = createModel(function () {
    const contractTypeOptions = [
        {
            label: '配件采购',
            value: 1,
        },
        {
            label: '工时费',
            value: 2,
        },
    ]

    const ontractStatusOptions = [
        {
            label: '合同生效',
            value: 0,
        },
        {
            label: '合同终止',
            value: 1,
        },
    ]

    const supplierRef = useRef({
        code: '',
        name: '',
    })
    const initSearch = {}
    //查询条件
    const [searchParam, setSearchParam] = useState<ISupplierContractPageSearchFields>(initSearch)
    //列表数据源
    const [dataSource, setDataSource] = useState<ISupplierContractDetails[]>([])
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const [loading, setLoading] = useState<boolean>(false)

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISupplierContractPageSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            code: supplierRef.current.code,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await supplierService.supplierContractPage(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
        setLoading(false)
    }

    // 删除
    const handleDelete = async (record: ISupplierContractDetails) => {
        globalPrompt('modal', {
            title: '删除',
            type: 'warning',
            text: `确定要删除合同编号--${record.contractCode}？`,
            okText: '确定',
            onOk: debounce(
                () =>
                    supplierService.supplierContractDelete(record.id).then(() => {
                        globalPrompt('message', { text: '删除成功！', type: 'success' })
                        loadData()
                    }),
                500
            ),
            cancelText: '取消',
            onCancel: () => {
                loadData()
            },
        })
    }

    // 弹窗
    // 添加弹窗状态
    const [modalVisible, setModalVisible] = useState(false)
    const [modalMode, setModalMode] = useState<'view' | 'edit' | 'add'>('view')
    const [currentRecord, setCurrentRecord] = useState<ISupplierContractDetails | ISupplierContractInsert | null>(null)

    // 编辑操作
    const handleEdit = (record: ISupplierContractDetails) => {
        setCurrentRecord(record)
        setModalMode('edit')
        setModalVisible(true)
    }

    const handleClose = () => {
        setModalVisible(false)
        setModalMode('view')
        setCurrentRecord(null)
    }

    const handleInsert = () => {
        setCurrentRecord({
            supplierCode: supplierRef.current.code,
            supplierName: supplierRef.current.name,
        })
        setModalMode('add')
        setModalVisible(true)
    }

    const changeContractStatus = async (record: ISupplierContractDetails, status: number) => {
        globalPrompt('modal', {
            title: '删除',
            type: 'warning',
            text: `确定要${status === 0 ? '生效' : '终止'}合同编号--${record.contractCode}？`,
            okText: '确定',
            onOk: debounce(
                () =>
                    supplierService.supplierContractUpdate({
                        id: record.id,
                        status,
                    }).then(() => {
                        globalPrompt('message', { text: `合同${status === 0 ? '生效' : '终止'}成功！`, type: 'success' })
                        loadData()
                    }),
                500
            ),
            cancelText: '取消',
            onCancel: () => {
                loadData()
            },
        })
    }

    return {
        searchParam,
        setSearchParam,
        dataSource,
        setDataSource,
        selectedRowKeys,
        setSelectedRowKeys,
        pgCfg,
        setPgCfg,
        loading,
        setLoading,
        loadData,
        supplierRef,
        handleDelete,
        handleEdit,
        modalVisible,
        modalMode,
        currentRecord,
        handleClose,
        handleInsert,
        contractTypeOptions,
        ontractStatusOptions,
        changeContractStatus,
    }
})
